import React from 'react';
import { FaRegWindowClose } from 'react-icons/fa';

//global components
import ModalButton from '../../../shared/Buttons/ModalButton';

//styles
import {
  ModalStyles,
  ModalContainerStyles,
  ModalHeaderStyles,
  ModalContentStyles,
  ModalItemStyles,
  TextStyles,
  TitleStyles,
} from '../../../SharedStyles';

const RemoveMember = (props) => {
  const closeModal = () => {
    props.handleCloseModal();
  };

  const handleSaveInfo = (e) => {
    e.preventDefault();
    props.removeMember(props.membership.id, props.userId);
    closeModal();
  };

  return (
    <ModalStyles>
      <ModalContainerStyles>
        {/* Header Bar */}
        <ModalHeaderStyles>
          <TitleStyles className='Title'>{props.title}</TitleStyles>
          <FaRegWindowClose className='Close' onClick={closeModal} />
        </ModalHeaderStyles>
        {/* Content Section */}
        <ModalContentStyles>
          {/* Section */}
          <ModalItemStyles padding='0 10px'>
            <TextStyles>{props.content}</TextStyles>
          </ModalItemStyles>
        </ModalContentStyles>
        {/* Button Component for Modals*/}
        <ModalButton
          containerMargin='10px 10px 0'
          containerAlign='right'
          buttonPadding='10px'
          buttonMargin='0'
          handleClick={handleSaveInfo}
          buttonText={props.button}
        />
      </ModalContainerStyles>
    </ModalStyles>
  );
};

export default RemoveMember;
